var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"mo-paging"},[_c('li',{class:[
            'paging-item',
            'paging-item--prev',
            { 'paging-item--disabled': _vm.index === 1 } ],on:{"click":_vm.prev}},[_vm._v("\n        首页\n    ")]),_c('li',{class:[
            'paging-item',
            'paging-item--first',
            { 'paging-item--disabled': _vm.index === 1 } ],on:{"click":_vm.first}},[_vm._v("\n        上一页\n    ")]),(_vm.showPrevMore)?_c('li',{class:['paging-item', 'paging-item--more']},[_vm._v("\n        ...\n    ")]):_vm._e(),_vm._l((_vm.pagers),function(pager){return _c('li',{key:pager,class:[
            'paging-item',
            { 'paging-item--current': _vm.index === pager } ],on:{"click":function($event){return _vm.go(pager)}}},[_vm._v("\n        "+_vm._s(pager)+"\n    ")])}),(_vm.showNextMore)?_c('li',{class:['paging-item', 'paging-item--more']},[_vm._v("\n        ...\n    ")]):_vm._e(),_c('li',{class:[
            'paging-item',
            'paging-item--last',
            { 'paging-item--disabled': _vm.index === _vm.pages } ],on:{"click":_vm.next}},[_vm._v("\n        下页\n    ")]),_c('li',{class:[
            'paging-item',
            'paging-item--next',
            { 'paging-item--disabled': _vm.index === _vm.pages } ],on:{"click":_vm.last}},[_vm._v("\n        尾页\n    ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }